/**
 * Forum Datenaustausch generalInvoiceRequest version used for a client's SV export.
 *
 * Selectable per client because the market is mid-transition: some practice
 * management systems accept only 5.00 while most still expect 4.50.
 * Anything unrecognised resolves to 4.50 so older builds and un-migrated
 * microservice instances stay correct. See docs/specs/sumex-xml-500.md §3.2.
 */
export enum SumexXmlVersion {
	V450 = "450",
	V500 = "500",
}

export const resolveSumexXmlVersion = (
	value: string | null | undefined
): SumexXmlVersion =>
	value === SumexXmlVersion.V500
		? SumexXmlVersion.V500
		: SumexXmlVersion.V450;

export const sumexXmlVersionOptions: {
	value: SumexXmlVersion;
	label: string;
}[] = [
	{ value: SumexXmlVersion.V450, label: "4.50 (Standard)" },
	{ value: SumexXmlVersion.V500, label: "5.00" },
];
